module.exports = __webpack_public_path__ + "img/costEffective.dadf03ec.jpg";